
import { Badge } from "@/components/ui/badge";
import { getPreviewUrl } from "@/utils/imageUtils";

interface ArtworkGridViewProps {
  artworks: any[];
  onArtworkClick: (artwork: any) => void;
  getArtistDisplayName: (creator: { name: string; surname: string; nick_name: string | null }) => string;
}

export const ArtworkGridView = ({ artworks, onArtworkClick, getArtistDisplayName }: ArtworkGridViewProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {artworks?.map((artwork) => (
        <div
          key={artwork.artwork_id}
          className="border rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => onArtworkClick(artwork)}
        >
          <div className="aspect-square relative">
            <img
              src={getPreviewUrl(artwork.preview)}
              alt={artwork.title}
              className="object-cover w-full h-full"
            />
          </div>
          <div className="p-4 space-y-2 text-center">
            <div className="flex flex-col items-center">
              <h3 className="font-semibold text-lg">{artwork.title}</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              {getArtistDisplayName(artwork.creators)}
            </p>
            {artwork.art_technique && (
              <p className="text-sm">{artwork.art_technique}</p>
            )}
            <div className="flex justify-center">
              <Badge variant={artwork.verified ? "default" : "secondary"}>
                {artwork.verified ? "Verified" : "Unverified"}
              </Badge>
            </div>
            <p className="text-sm text-muted-foreground">
              {artwork.editions?.length || 0} edition{artwork.editions?.length !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
